interface Window {
  __env?: any;
}

import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTableModule } from "@angular/material/table";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { PdfJsViewerModule } from "ng2-pdfjs-viewer";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatSortModule } from "@angular/material/sort";
import { MatSelectModule } from "@angular/material/select";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatCheckboxModule } from "@angular/material/checkbox";

export function loadRuntimeConfig(): () => Promise<void> {
  return () => {
    return fetch("assets/config/runtime-config.json")
      .then((res) => {
        if (!res.ok) throw new Error("Could not load runtime config");
        return res.json();
      })
      .then((config) => {
        globalThis.__env = config;
        const faviconUrl =
          globalThis.__env.assetBaseUrl + "assets/image/favicon.ico";
        sessionStorage.setItem("faviconUrl", faviconUrl);
      })
      .catch((err) => console.error("Error loading runtime config", err));
  };
}

@NgModule({
  declarations: [
  ],
  bootstrap: [],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTabsModule,
    CommonModule,
    MatTableModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    PdfJsViewerModule,
    MatSnackBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSortModule,
    MatSelectModule,
    //MatPaginatorModule,
    MatTooltipModule,
    MatCheckboxModule,
  ],
  providers: [
  ],
})
export class AppModule {}
